import {
  Grid,
  LinearProgress,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import {
  GamePlanItemType,
  type GamePlanItem,
  type GamePlanPath,
} from "../../../components/wizard/use-game-plan";
import { Status } from "../../../models/gameplan";
import { GamePlanOption } from "./game-plan-option.component";
import { useStyles } from "./learning-path-menu.styles";

type Props = {
  focusedItem: GamePlanPath["index"];
  items: GamePlanPath[];
  isLoading: boolean;
};

export const LearningPathMenu = ({ focusedItem, items, isLoading }: Props) => {
  const classes = useStyles();
  const goalCommitment = items?.find(
    (item) => item.type === GamePlanItemType.COMMITMENT
  );

  const generateOptions = (levelItems: GamePlanPath[]) => {
    return levelItems
      ?.filter((i) => i.type != GamePlanItemType.COMPLETED)
      .map((gamePlan) => {
        const isSelectable =
          gamePlan.type === GamePlanItemType.COMMITMENT ||
          gamePlan.type === GamePlanItemType.WORKOUT ||
          gamePlan.type === GamePlanItemType.DISCOVER ||
          gamePlan.type === GamePlanItemType.LESSON ||
          gamePlan.type === GamePlanItemType.QUICKWIN;
        const isIntro =
          gamePlan.type === GamePlanItemType.LESSON &&
          gamePlan.children.length === 1;
        const index = isIntro ? gamePlan.children[0].index : gamePlan.index;
        const isFocused = isSelectable && focusedItem === index;
        const isOpened =
          !gamePlan.children
            ?.filter((item) => item.type !== GamePlanItemType.COMPLETED)
            .every((item) => item.status === Status.NEW) &&
          !gamePlan.children
            ?.filter((item) => item.type !== GamePlanItemType.COMPLETED)
            .every((item) => item.status === Status.COMPLETED);

        return (
          <GamePlanOption
            key={`${gamePlan.type}${(gamePlan.item as GamePlanItem)?.id ?? 0}`}
            isFocused={isFocused}
            gameplan={
              (gamePlan.item as GamePlanItem)?.order === 0
                ? { ...gamePlan.children[0], ...gamePlan }
                : gamePlan
            }
            isOpen={isOpened}
            isDisabled={
              gamePlan.type !== GamePlanItemType.COMMITMENT &&
              goalCommitment?.status !== Status.COMPLETED
            }
          >
            {gamePlan.children &&
              (gamePlan.item as GamePlanItem).order != 0 &&
              generateOptions(gamePlan.children)}
          </GamePlanOption>
        );
      });
  };

  return (
    <Grid container className={classes.navMenu}>
      <Grid item xs={12}>
        <Drawer open variant="permanent" className={classes.drawer}>
          <List id="gameplan-wt-1">
            <ListItem>
              <Typography variant="h6">Game Plan</Typography>
              <div className={classes.toolbar} />
            </ListItem>
            {isLoading ? (
              <div data-testid="loading">
                <LinearProgress color="secondary" />
              </div>
            ) : (
              <>{generateOptions(items)}</>
            )}
          </List>
        </Drawer>
      </Grid>
    </Grid>
  );
};
